import { Form, FormInstance, Input } from 'antd';
import { useTranslation } from 'react-i18next';
import { FormField, FormTextArea } from '../../../../../components/form/FormBasic';
import CanvasComponent from '../../../../../components/form/CanvasComponent';
import { useState } from 'react';
import { FormFieldTypeEnum } from '../../../../../enums/FormFieldTypeEnum';
import {
  REGEX_ALL_ALLOWED_SAFE_FILTER,
  REGEX_LETTERS_SPACE_FULLSTOP_SAFE_FILTER,
} from '../../../../../constants/regex';
import {
  maxLengthRule,
  minLengthRule,
  noSpacesOnlyRule,
  regexRule,
  requiredRule,
} from '../../../../../helpers/formHelper';

interface TaskCompletionFormProps {
  form: FormInstance;
  handleCancel: () => void;
  handleComplete: () => void;
}

const TaskCompletionForm: React.FC<TaskCompletionFormProps> = ({
  form,
  handleCancel,
  handleComplete,
}) => {
  const { t } = useTranslation(['task', 'price']);
  const [hasDrawnSignature, setHasDrawnSignature] = useState(false);

  const updateSignatureStatus = (drew: boolean, dataUrl: string) => {
    form.setFieldValue('hasSignature', drew);
    form.setFieldValue('signature', dataUrl);
    setHasDrawnSignature(drew);
  };

  return (
    <>
      <Form layout="vertical" form={form} name="addProductForm" className="mt-2 w-full">
        {/* Respondent Name */}
        <FormField
          name="respondent"
          label={t('price:respondentName')}
          placeholder={t('price:RespondentFieldPlaceholder')}
          isRequired={true}
          rules={[
            requiredRule(t, t('price:respondentName')),
            noSpacesOnlyRule(t, t('price:respondentName')),
            minLengthRule(t, t('price:respondentName'), 3),
            maxLengthRule(t, t('price:respondentName'), 100),
            regexRule(t, REGEX_LETTERS_SPACE_FULLSTOP_SAFE_FILTER),
          ]}
          disabled={false}
          type={FormFieldTypeEnum.INPUT}
          allowLeadingTrailingSpaces={true}
          useCustomRules={true}
        />

        {/* Signature Initial */}
        <FormField
          name="signatureInitial"
          label={t('price:signatureOfRespondent')}
          placeholder={t('price:RespondentSignatureFieldPlaceholder')}
          isRequired={true}
          rules={[
            requiredRule(t, t('price:signatureOfRespondent')),
            noSpacesOnlyRule(t, t('price:signatureOfRespondent')),
            minLengthRule(t, t('price:signatureOfRespondent'), 1),
            maxLengthRule(t, t('price:signatureOfRespondent'), 100),
            regexRule(t, REGEX_LETTERS_SPACE_FULLSTOP_SAFE_FILTER),
          ]}
          disabled={false}
          type={FormFieldTypeEnum.INPUT}
          allowLeadingTrailingSpaces={true}
          useCustomRules={true}
        />

        <FormTextArea
          name="remark"
          label={t('price:generalObservations')}
          rules={[
            regexRule(t, REGEX_ALL_ALLOWED_SAFE_FILTER),
            noSpacesOnlyRule(t, t('price:generalObservations')),
            minLengthRule(t, t('price:generalObservations'), 3),
            maxLengthRule(t, t('price:generalObservations'), 200),
          ]}
          useCustomRules={true}
          placeholder={t('price:RespondentObservationsFieldPlaceholder')}
          disabled={false}
          isRequired={false}
        />

        <Form.Item
          name="signature"
          label={t('task:signature')}
          rules={[{ required: true, message: t('task:signatureRequired') }]}
        >
          <CanvasComponent updateSignatureStatus={updateSignatureStatus} />
        </Form.Item>

        <Form.Item name="hasSignature" hidden>
          <Input hidden />
        </Form.Item>
      </Form>
    </>
  );
};

export default TaskCompletionForm;
